// extracted by mini-css-extract-plugin
export default {"ref-cell":"styles_ref-cell__CXQMc","copy-button":"styles_copy-button__DBg7G"};